<template>
  <team-admin-dash-board v-if="showTeamAdmin" />
  <admin-dash-board v-else-if="isAdmin" />
  <CupAdminDashBoard v-else-if="isCupAdmin" />
  <div v-else-if="loggedIn">
    <h3>Postfach</h3>
    <p>Für dich ist kein Mannschafts- oder Verwaltungsbereich freigegeben.</p>
    <Button label="Nachrichten öffnen" icon="pi pi-envelope" @click="routeToInbox" />
  </div>
  <div v-else>
    <h3>Geschlossener Bereich</h3>
    <Button label="Login erforderlich" @click="routeToLogin" />
  </div>
</template>

<script>
import UserPermissionsService from "../services/UserPermissionsService/UserPermissionsService";
import AdminDashBoard from "./admin/AdminDashBoard.vue";
import TeamAdminDashBoard from "./teamAdmin/TeamAdminDashBoard.vue";
import CupAdminDashBoard from "./cupadmin/CupAdminDashBoard.vue";
import Button from "primevue/button";
export default {
  name: "DashBoard",
  components: {
    AdminDashBoard,
    TeamAdminDashBoard,
    CupAdminDashBoard,
    Button,
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    isAdmin() {
      return UserPermissionsService.userHasRole("LEAGUE_MAINTAINER");
    },
    isTeamAdmin() {
      return UserPermissionsService.userHasRole("TEAM_MANAGER");
    },
    isCupAdmin() {
      return (
        UserPermissionsService.userHasRole("CUP_ADMIN") ||
        UserPermissionsService.userHasRole("LEAGUE_MANAGER")
      );
    },
    showTeamAdmin() {
      return this.isTeamAdmin && !this.isAdmin;
    },
  },
  watch: {
    loggedIn: {
      immediate: true,
      handler(isLoggedIn) {
        if (!isLoggedIn) {
          this.$router.push("/login");
        }
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    routeToLogin() {
      this.$router.push("/login");
    },
    routeToInbox() {
      this.$router.push("/postfach");
    },
  },
};
</script>

<style>
.p-overlay-badge .p-badge {
  transform: translate(0%, -25%);
}
</style>
